import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AssesmentHistory from "./AssesmentHistory";
import {getAssessmentHistory} from "../../../services/redux/Training/action";

const mapStateToProps = (state) => ({
    testHistory: state.Training.assessmentHistory
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getAssessmentHistory
        },
        dispatch
    );


export default connect(mapStateToProps, mapDispatchToProps)(AssesmentHistory);